import { GlobalConfigType, setApplicationStep } from 'actions'
import cloneDeep from 'clone-deep'
import { LoanFieldProps } from 'config'
import { store } from 'reducers'
import { LoanType } from 'reducers/loanDetail.reducer'

import { BorrowerSeperator, CoBorrowers } from '../config'
import { borrowerMenuKey } from '../util'

export const signAppValidate = (borrowerSeperator: BorrowerSeperator, updateStore = false, afterRemoved = false) => {
  const { borrower, step, loanDetail, globalConfigReducer } = store.getState()

  const loanFieldProperties = globalConfigReducer[GlobalConfigType.LoanFields] as LoanFieldProps
  if (((loanFieldProperties as any)['visibility'] || {})['sign'] === false) {
    return true
  }

  let success = true
  const data = borrower[borrowerSeperator]
  if (!data) return false

  const agreeToSignRequired = ![LoanType.CORRESPONDENT, LoanType.TABLEFUNDER].includes(loanDetail.loanType)

  if (borrowerSeperator === BorrowerSeperator.BORROWER) {
    if (data.agreeToSign !== true && agreeToSignRequired) {
      success = false
    } else {
      const includedKeys = loanDetail.includeCoborrower
        ? [BorrowerSeperator.BORROWER, ...CoBorrowers.filter((k) => borrower[k]?.isIncluded)]
        : [BorrowerSeperator.BORROWER]
      const allSigned = includedKeys.every((k) => !!borrower[k]?.signedDate)
      // Legacy: loans signed with old flow have only primary signedDate/signedPdfKey; treat as complete
      const legacyOneShotSigned =
        !!borrower.borrower?.signedDate && !!borrower.borrower?.signedPdfKey && !data.signRequestSent
      const complete = (allSigned || legacyOneShotSigned) && !data.signRequestSent
      if (!complete) {
        success = false
      }
    }
  }

  if (CoBorrowers.includes(borrowerSeperator)) {
    if (data.agreeToSign !== true && agreeToSignRequired) success = false
    // Agreeing to the terms is not a signature. The check stays off until this borrower signs,
    // whether or not a signature request has been sent. An override counts as signed.
    if (!data.signedDate && !data.overriden) success = false
  }

  if (data.exempt) success = true

  if (afterRemoved) success = false
  if (updateStore) {
    let application = cloneDeep(step.application)
    const key = borrowerMenuKey(borrowerSeperator, 'sign')
    application[key] = success ? 1 : -1
    store.dispatch(setApplicationStep(application))
  }

  return success
}
